import { css, cx } from '@fable/theme'
import { CompProps } from '@fable/types'
import { StatsProfileSectionTitle } from './StatsProfileSectionTitle'
import { StatsThemeSectionBlurs } from '../../theme/components/section_blurs'
import { StatsSectionType } from '../../theme'

export interface StatsProfileSectionProps {
  className?: string
  title?: string
  type: StatsSectionType
  hidden?: boolean
}

export const StatsProfileSection = ({
  children,
  className = '',
  type,
  title,
  hidden = false,
}: CompProps<StatsProfileSectionProps>) => {
  const isHero = type === 'hero'
  if (hidden) return null

  return (
    <section
      className={cx(
        css`
          margin-top: ${isHero ? '0' : '-24px'};
          padding-bottom: 24px;
          width: 100%;
          border-radius: 24px 24px 0 0;
          position: relative;
          overflow: hidden;
          z-index: 1;
        `,
        className
      )}
    >
      <StatsThemeSectionBlurs type={type} />
      <div
        className={css`
          width: 100%;
          position: relative;
          z-index: 5;
        `}
      >
        {title ? <StatsProfileSectionTitle title={title} /> : null}
        {children}
      </div>
    </section>
  )
}
